import { useCallback } from 'react';
import _ from 'lodash';
import { renderContentFromMetadata } from '@jutro/uiconfig';
import SgAccessibilityUtils from 'sg-accessibility-util';
import { useLocation } from 'react-router-dom';

import metadata from './SgSkipNavigationLink.metadata.json5';
import './SgSkipNavigationLink.messages';

function SgSkipNavigationLink(props) {
    const { isCEP } = props;

    const path = useLocation().pathname;

    const skipFocusToMainContent = useCallback(() => {
        const focusElementQuery = SgAccessibilityUtils.getFirstFocusableElementQuery(path, isCEP);
        const mainContent = document.getElementById('customerActionsModal')
            || document.getElementById('mainContent') || document.getElementById('cepContent');
        const focusableElements = _.filter(mainContent.querySelectorAll(focusElementQuery),
            (elem) => elem.offsetHeight !== 0 && elem.offsetWidth !== 0);

        let tabIndexChangedForContentFocussing = false;
        const initialTabIndex = focusableElements[0].tabIndex;
        // enable first element to be focussed on pages with content that should not be missed before first interactable element
        // first tab after this will go to first interaction
        if (focusableElements[0].tabIndex !== 0) {
            focusableElements[0].tabIndex = 0;
            focusableElements[0].style.outline = 'none';
            tabIndexChangedForContentFocussing = true;
        }
        focusableElements[0].focus();
        // revert tab index for further navigation
        if (tabIndexChangedForContentFocussing) {
            focusableElements[0].tabIndex = initialTabIndex;
        }
    }, [isCEP, path]);

    const overrides = {
    };

    const resolvers = {
        resolveCallbackMap: {
            skipFocusToMainContent
        }
    };

    return renderContentFromMetadata(metadata.componentContent, overrides, resolvers);
}

export default SgSkipNavigationLink;
